import { Component } from '@angular/core';
import { ItemTypes } from '../../list-detail-management/model/list-detail-management-view.model';
import { ListGroupsBaseComponent } from '../list-groups-base.component';

@Component({
  selector: 'app-list-groups-mobile',
  templateUrl: './list-groups-mobile.component.html',
  styleUrls: ['./list-groups-mobile.component.scss'],
})
export class ListGroupsMobileComponent extends ListGroupsBaseComponent {
  constructor() {
    super();
  }

  onShowAllGroups(groupHeaderId: string) {
    this.changeGroupEmitter.emit(ItemTypes.showAllGroups);
    this.scrollToSelectedGroup(groupHeaderId);
  }
}
